import { render, staticRenderFns } from "./table-expand.vue?vue&type=template&id=61422abb&scoped=true"
import script from "./table-expand.vue?vue&type=script&lang=js"
export * from "./table-expand.vue?vue&type=script&lang=js"
import style0 from "./table-expand.vue?vue&type=style&index=0&id=61422abb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61422abb",
  null
  
)

export default component.exports